import { render, staticRenderFns } from "./GradeAudit.vue?vue&type=template&id=5d83d556&scoped=true"
import script from "./GradeAudit.vue?vue&type=script&lang=js"
export * from "./GradeAudit.vue?vue&type=script&lang=js"
import style0 from "./GradeAudit.vue?vue&type=style&index=0&id=5d83d556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83d556",
  null
  
)

export default component.exports